import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, CircularProgress, Divider, } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import CustomButton from "../../../components/common/CustomButton";
import CustomTextField from "../../../components/common/CustomTextField";
import CustomTextarea from "../../../components/common/CustomTextarea";
import { genericPost } from '../../../services/authServices';
import { NEWS_CREATE, } from '../../../services/apiRoutes';
import { t } from "../../../constants/translationHelper";
import CustomAutocomplete from "../../../components/common/CustomAutoComplete";
import axios from "axios";


const ValidationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    content: Yup.string().required('Content is required'),
    featuredImage: Yup.mixed().required('Featured Image is required'),
    category: Yup.string().required('Category is required'),
    metaTitle: Yup.string().required('Meta Title is required'),
    metaDescription: Yup.string().required('Meta Description is required'),
    views: Yup.number().required('Views is required'),
    publishedAt: Yup.date().required('Published Date is required'),
    status: Yup.string().required('Status is required'),
});

const CreateNewsPost = ({ handleClose, setMessage, fetchData, blogCategory, blogStatus }) => {
    // ✅ Image handler (same as blog)
    const handleImageChange = (event, setFieldValue) => {
        const file = event.target.files[0];
        if (file) {
            setFieldValue("featuredImage", file);
        }
    };


    // const handleSubmit = async (values, { setSubmitting }) => {
    //     try {
    //         const payload = {
    //             title: values.title,
    //             content: values.content,
    //             featuredImage: values.featuredImage,
    //             category: values.category,
    //             metaTitle: values.metaTitle,
    //             metaDescription: values.metaDescription,
    //             views: values.views,
    //             publishedAt: values.publishedAt,
    //             status: values.status,
    //         };
    //         const response = await genericPost(NEWS_CREATE, payload);

    //         if (response.status === 201) {
    //             setMessage({
    //                 open: true,
    //                 text: response?.data?.message || "news added successfully",
    //                 type: "success",
    //             });
    //             setTimeout(() => {
    //                 fetchData();
    //                 handleClose();
    //             }, 1000);
    //         } else {
    //             alert('Something went wrong');
    //         }
    //     } catch (error) {
    //         alert('Something went wrong');
    //     } finally {
    //         setSubmitting(false);
    //     }
    // };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const formData = new FormData();

            formData.append("title", values.title);
            formData.append("content", values.content);
            formData.append("featuredImage", values.featuredImage);
            formData.append("category", values.category);
            formData.append("metaTitle", values.metaTitle);
            formData.append("metaDescription", values.metaDescription);
            formData.append("views", values.views);
            formData.append("publishedAt", values.publishedAt);
            formData.append("status", values.status);

            const authToken = sessionStorage.getItem('accessToken');

            const response = await axios.post(NEWS_CREATE, formData, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "multipart/form-data"
                }
            });

            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "News added successfully",
                    type: "success",
                });

                setTimeout(() => {
                    fetchData();
                    handleClose();
                }, 1000);
            } else {
                alert("Something went wrong");
            }

        } catch (error) {
            alert("Something went wrong");
        } finally {
            setSubmitting(false);
        }
    };


    const [formData] = useState({
        title: '',
        content: '',
        featuredImage: '',
        category: '',
        metaTitle: '',
        metaDescription: '',
        views: 0,
        publishedAt: '',
        status: '',

    });

    return (
        <Box sx={{ mx: 'auto', mt: 0 }}>
            <Formik
                initialValues={formData}
                validationSchema={ValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                    <Form>
                        <Grid
                            container
                            spacing={1}
                            style={{ position: "sticky" }}
                        >
                            <Grid item xs={4} md={4}>
                                <Typography sx={{ fontWeight: 600 }} style={{ color: "#212529", fontSize: "18px", paddingTop: "5px" }}>
                                    {t("Add News Post")}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={8}
                                md={8}
                                style={{ display: "flex", justifyContent: "flex-end" }}
                            >
                                <Box style={{ display: "flex" }}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={2} sx={{ px: "5%", paddingTop: "5px" }}>

                            <Grid item xs={12} md={6}>
                                <CustomTextarea
                                    placeholder="Enter title"
                                    name="title"
                                    fieldLabel="Title"
                                    required
                                    value={values.title}
                                    onChange={handleChange}
                                    error={touched.title && !!errors.title}
                                    helperText={touched.title && errors.title}
                                />
                            </Grid>

                            {/* Category */}
                            <Grid item xs={12} md={6}>

                                <CustomAutocomplete
                                    options={blogCategory}
                                    fieldLabel="Category"
                                    required={true}
                                    getOptionLabel={(option) => option.title || ""}
                                    value={
                                        blogCategory.find((option) => option.id === values.category) || null
                                    }
                                    onChange={(e, newValue) =>
                                        setFieldValue("category", newValue ? newValue.id : "")
                                    }
                                    placeholder="Select Category"
                                    error={touched.category && !!errors.category}
                                    helperText={touched.category && errors.category}
                                />
                            </Grid>

                            {/* Content */}
                            <Grid item xs={12}>
                                <CustomTextarea
                                    placeholder="Enter content"
                                    name="content"
                                    fieldLabel="Content"
                                    required
                                    value={values.content}
                                    onChange={handleChange}
                                    error={touched.content && !!errors.content}
                                    helperText={touched.content && errors.content}
                                />
                            </Grid>
                            {/* Meta Title */}
                            <Grid item xs={12} md={6}>
                                <CustomTextarea
                                    placeholder="Enter meta title"
                                    name="metaTitle"
                                    fieldLabel="Meta Title"
                                    required
                                    value={values.metaTitle}
                                    onChange={handleChange}
                                    error={touched.metaTitle && !!errors.metaTitle}
                                    helperText={touched.metaTitle && errors.metaTitle}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Featured Image *</Typography>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleImageChange(e, setFieldValue)}
                                />

                                {touched.featuredImage && errors.featuredImage && (
                                    <Typography variant="caption" color="error">
                                        {errors.featuredImage}
                                    </Typography>
                                )}
                            </Grid>


                            {/* Meta Description */}
                            <Grid item xs={12}>
                                <CustomTextarea
                                    placeholder="Enter meta description"
                                    name="metaDescription"
                                    fieldLabel="Meta Description"
                                    required
                                    value={values.metaDescription}
                                    onChange={handleChange}
                                    error={touched.metaDescription && !!errors.metaDescription}
                                    helperText={touched.metaDescription && errors.metaDescription}
                                />
                            </Grid>

                            {/* Views */}
                            <Grid item xs={12} md={4}>
                                <CustomTextField
                                    type="number"
                                    placeholder="Enter views"
                                    name="views"
                                    fieldLabel="Views"
                                    required
                                    value={values.views}
                                    onChange={handleChange}
                                    error={touched.views && !!errors.views}
                                    helperText={touched.views && errors.views}
                                />
                            </Grid>

                            {/* Published Date */}
                            <Grid item xs={12} md={4}>
                                <CustomTextField
                                    type="date"
                                    name="publishedAt"
                                    fieldLabel="Published Date"
                                    required
                                    value={values.publishedAt}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    error={touched.publishedAt && !!errors.publishedAt}
                                    helperText={touched.publishedAt && errors.publishedAt}
                                />
                            </Grid>

                            {/* Status */}
                            <Grid item xs={12} md={4}>
                                <CustomAutocomplete
                                    options={blogStatus}
                                    fieldLabel="Status"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={blogStatus.find((option) => option.id === values.status) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('status', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select status"
                                    error={touched.status && !!errors.status}
                                    helperText={touched.status && errors.status}
                                />
                            </Grid>

                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default CreateNewsPost;
